<span role="presentation" title="Loading...">
  <lib-ball class="left-cue-ball" [ball]="'white'" />
  <lib-ball class="object-ball" [ball]="ball" />
  <lib-ball class="right-cue-ball" [ball]="'white'" />
</span>
